import script from "./petty-cash.vue?vue&type=script&setup=true&lang=js"
export * from "./petty-cash.vue?vue&type=script&setup=true&lang=js"

import "./petty-cash.vue?vue&type=style&index=0&id=7ec1b9a2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec1b9a2"]])

export default __exports__